namespace TabAurous.Inventory {
    export interface MixingDetailsForm {
        ProductCode: Serenity.StringEditor;
        NewProductId: Serenity.LookupEditor;
        ProductId: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        SieveId: Serenity.StringEditor;
        QualityId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NewPieces: Serenity.IntegerEditor;
        NewWeight: Serenity.DecimalEditor;
    }

    export class MixingDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.MixingDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MixingDetailsForm.init)  {
                MixingDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = CommonCategoryLookup;
                var w3 = s.IntegerEditor;
                var w4 = s.DecimalEditor;

                Q.initFormType(MixingDetailsForm, [
                    'ProductCode', w0,
                    'NewProductId', w1,
                    'ProductId', w0,
                    'AttributeId', w0,
                    'ProductTypeId', w1,
                    'CategoryId', w2,
                    'SubCategoryId', w1,
                    'StoneSizeId', w1,
                    'SieveId', w0,
                    'QualityId', w1,
                    'ShapeId', w1,
                    'StoneColorId', w1,
                    'Pieces', w3,
                    'Weight', w4,
                    'NewPieces', w3,
                    'NewWeight', w4
                ]);
            }
        }
    }
}
